export default {"src":"/_next/static/media/information-profile.22cef2de.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};